import axios from 'axios';
import { AUTH_API, BETA_SITE_URL } from '../../Config';

const axiosInstance = axios.create({
  timeout: 30000
});
updateAuthorizationHeader();

let isRefreshing = false;
let requestsQueue = [];

function updateAuthorizationHeader(token) {
  const accessToken = token || localStorage.getItem('accessToken');
  axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
}

function handleRegionError(error) {
  if (
    error.response && 
    error.response.status === 403 && 
    error.response.data && 
    error.response.data.error === 'UNAVAILABLE_REGION'
  ) {
    window.location.href = `${BETA_SITE_URL}/`;
  }
}

const processQueue = (newToken = null) => {
  requestsQueue.forEach(pending => {
      pending.originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
      pending.resolve(axiosInstance(pending.originalRequest));
  });

  requestsQueue = [];
};

function processQueueWithError(error) {
    requestsQueue.forEach(pending => {
      pending.reject(error);
    });
    requestsQueue = [];
}

const refreshToken = async () => {
  try {
    const refreshToken = localStorage.getItem('refreshToken');

    const response = await axios.post(`${AUTH_API}token/refresh`, { refreshToken, clientType: 'web' });

    const { accessToken, refreshToken: newRefreshToken } = response.data.result;

    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', newRefreshToken);

    document.dispatchEvent(new Event("tokenRefreshed"));

    updateAuthorizationHeader(accessToken);

    return accessToken;
  } catch (error) {
    localStorage.clear();
    
    processQueueWithError(error);

    window.location.href = `${BETA_SITE_URL}/logout`;
  }
};

// Helper to generate clean messages
function getFriendlyErrorMessage(error) {
  if (error.code === 'ECONNABORTED') return "Request timed out. Please try again.";
  if (!error.response) return "Network error. Please check your connection.";
  if (error.response && error.response.data && error.response.data.ErrorMessage) {
      return error.response.data.ErrorMessage;
  }
  return "An unexpected error occurred.";
}

axiosInstance.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    console.log('originalRequest: ', originalRequest);

    if (error.response && error.response.status === 401) {
      return new Promise((resolve, reject) => {
        requestsQueue.push({ resolve, reject, originalRequest });

        if (!isRefreshing) {
          isRefreshing = true;
          refreshToken().then(newToken => {
              processQueue(newToken);
              isRefreshing = false;
          });
        }
      });
    }

    handleRegionError(error);

    const errorMessage = getFriendlyErrorMessage(error);

    return {
      // We return a normal object, effectively "swallowing" the error
      data: {
        Response: 0, // Set to 0 so your actions go to the 'else' block
        ErrorMessage: errorMessage, 
        NoAccess: false, // Default flags to prevent crashes
        BadToken: false,
        isNetworkError: true // Optional flag for debugging
      },
      status: error.response ? error.response.status : 0,
      statusText: 'Error handled by interceptor'
    };

    // return Promise.reject(error);
  }
);
export default axiosInstance;